module.exports = __webpack_public_path__ + "img/house-church-walk_bx.a0126906.jpg";